// Wishlist


jQuery(document).ready(function(){
    var ajax = new Ajax();
    initWishlistSaveProductId ();
    initWishlistChecked ();
    initCompareSaveProductId ();
    initCompareChecked ();
});

function initWishlistSaveProductId () {
    $(".nt-wishlist").click(function() {

        $('.loader').show();
        var nt_wishlist_product_id = $(this).data('handle');
        var nt_wishlist_array = [];
        if(jQuery.cookie('nt-wishlist-product-id')) {
            nt_wishlist_array = jQuery.cookie('nt-wishlist-product-id')
            nt_wishlist_array = JSON.parse(nt_wishlist_array);
            var nt_wishlist_index = nt_wishlist_array.indexOf(nt_wishlist_product_id);
            if(nt_wishlist_index == -1){
                nt_wishlist_array.push(nt_wishlist_product_id)
            }
            jQuery.cookie('nt-wishlist-product-id', JSON.stringify(nt_wishlist_array), {expires:7, path:'/'});
        }else {
            nt_wishlist_array.push(nt_wishlist_product_id);
            jQuery.cookie('nt-wishlist-product-id', JSON.stringify(nt_wishlist_array), {expires:7, path:'/'});
        }
        console.log(jQuery.cookie('nt-wishlist-product-id'));

        toastr.success('<span style="font-weight:bold">' + $(this).attr( "data-name" ) + '</span>' + 'was successfully added to your' + '<a href="/pages/wishlists">' + 'Wishlist' + '</a>!');

        $(this).addClass('checked-wishlist');

        setTimeout(function(){
            $('.loader').hide();
        }, 500);

    })
}

function initWishlistChecked () {

    if(jQuery.cookie('nt-wishlist-product-id')){
        var nt_wishlist_array = jQuery.cookie('nt-wishlist-product-id')
        nt_wishlist_array = JSON.parse(nt_wishlist_array);
        jQuery('a.nt-wishlist').each(function(){
            var nt_wishlist_handle = $(this).data('handle')
            var nt_wishlist_index = nt_wishlist_array.indexOf(nt_wishlist_handle);
            if(nt_wishlist_index >= 0){
                $(this).addClass('checked-wishlist');
            }
        })
    }

}
